import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  Paper as MuiPaper,
  Toolbar,
  Tooltip,
  Typography,
  Divider,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import InputField from "../Components/inputfield";
import BasicBreadcrumbs from "@material-ui/core/Breadcrumbs";
import ButtonComponent from "../Components/buttton";
import {
  GetSingleData,
  UpdateSingleDoc,
  updateAdmin,
} from "../NetworkCalls/Admin/ServerReq";
import { useNavigate } from "react-router-dom";

const AdminProfile = () => {
  const [loader, setLoader] = useState(false);
  const [Error, setError] = useState("");
  const [data, setData] = useState({});
  console.log("data");
  console.log(data);
  const history = useNavigate();

  useEffect(() => {
    const getUserDeails = async () => {
      try {
        const response = await GetSingleData("AppInfo", "settings");
        setData(response);
        setLoader(false);
      } catch (err) {
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getUserDeails();
  }, []);

  const handleOnchange = (e) => {
    const { name, value } = e.target;

    setData((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  };

  const handleEditAdminsDetails = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      const response = await UpdateSingleDoc("AppInfo", "settings", data);
      localStorage.removeItem("uid");
      history({ pathname: "/" });
      setLoader(false);
    } catch (error) {
      setLoader(true);
      setError(error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <React.Fragment>
        <Grid
          style={{ marginBottom: "10px" }}
          justify="space-between"
          container
          spacing={24}
        >
          <Grid item>
            <Typography
              gutterBottom
              variant="h3"
              display="inline"
              style={{
                fontWeight: "700",
                letteSpacing: "0.2px",
                fontSize: "25px",
              }}
            >
              Add Admin
            </Typography>
          </Grid>
        </Grid>

        <Divider
          my={6}
          style={{
            marginTop: "20px",
            marginBottom: "20px",
            backgroundColor: "#fafafa",
          }}
        />

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <BasicBreadcrumbs />
          </Grid>
        </Grid>

        <Divider
          my={6}
          style={{
            backgroundColor: "#fafafa",
          }}
        />
        <div className="dashboard_container">
          <form
            onSubmit={handleEditAdminsDetails}
            style={{
              backgroundColor: "#fff",
              border: "1px solid rgba(76, 78, 100, 0.25)",
              borderRadius: "10px",
              padding: "10px",
              width: "97%",
            }}
          >
            <Grid style={{ marginBottom: "10px" }} container spacing={2}>
              <Grid item xs={12} xl={6} lg={6} md={6}>
                <InputField
                  type="text"
                  name="admin_email"
                  required
                  value={data?.admin_email}
                  placeholder={"Admin Email"}
                  onChange={handleOnchange}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <InputField
                  type="password"
                  placeholder="Password"
                  name="admin_password"
                  value={data?.admin_password}
                  required
                  onChange={handleOnchange}
                />
              </Grid>
            </Grid>

            <Box mt={2}>
              <Typography style={{ color: "#E12F2F" }}>{Error}</Typography>
            </Box>

            <Grid
              container
              justifyContent="center"
              sx={{ marginTop: "30px", width: "50%" }}
            >
              <ButtonComponent
                loader={loader}
                type="submit"
                name="Save"
                dashboard={true}
              />
            </Grid>
          </form>
        </div>
      </React.Fragment>
    </>
  );
};
export default AdminProfile;
